export type SectionIdsType = (typeof Sections)[number]['id'];

export const Sections = [
  {
    id: 'SPECIFICATION',
    menuTitleTranslationKey: 'specification.heading',
  },
  {
    id: 'ADVERTISEMENT_DETAILS',
    menuTitleTranslationKey: 'details.sellerDescription',
  },
  {
    id: 'FINANCIAL_PRODUCTS',
    menuTitleTranslationKey: 'financialProducts.heading',
  },
  {
    id: 'TECHNICAL_PARAMETERS',
    menuTitleTranslationKey: 'technicalParameters.heading',
  },
  {
    id: 'FEATURES',
    menuTitleTranslationKey: 'features.heading',
  },
  {
    id: 'DETAILS',
    menuTitleTranslationKey: 'details.heading',
  },
  {
    id: 'CERTIFICATE',
    menuTitleTranslationKey: 'certificate.heading',
  },
  {
    id: 'ELECTRICAL_PARAMETERS',
    menuTitleTranslationKey: 'electricalParameters.heading',
  },
  {
    id: 'WARRANTY',
    menuTitleTranslationKey: 'warranty.heading',
  },
  {
    id: 'DISCLAIMER',
    menuTitleTranslationKey: 'disclaimer.heading',
  },
] as const;

export type SectionId = (typeof Sections)[number]['id'];
